import axios from 'axios';
import * as qs from 'qs';
import resolvePath from 'utils/resolvePath';
// Action
const FORWARD = 'favorites/forward';
const CLEAR = 'favorites/clear';
const GET_FAVORITES_REQUEST = 'favorites/getFavoritesRequest';
const GET_FAVORITES_SUCCESS = 'favorites/getFavoritesSuccess';
const GET_FAVORITES_FAILURE = 'favorites/getFavoritesFailure';
// 仮。実際はGET_FAVORITES_ID_REQUEST, SUCCESS, FAILUREのセットで管理するはず。
const GET_FAVORITES_ID = 'favorites/getFavoritesId';
const CLEAR_FAVORITES_ID = 'favorites/clearFavoritesId';
const POST_FAVORITES_REQUEST = 'favorites/postFavoritesRequest';
const POST_FAVORITES_SUCCESS = 'favorites/postFavoritesSuccess';
const POST_FAVORITES_FAILURE = 'favorites/postFavoritesFailure';
const DELETE_FAVORITES_REQUEST = 'favorites/deleteFavoritesRequest';
const DELETE_FAVORITES_SUCCESS = 'favorites/deleteFavoritesSuccess';
const DELETE_FAVORITES_FAILURE = 'favorites/deleteFavoritesFailure';
// Action Creator
export const forward = () => {
    return {
        type: FORWARD,
    };
};
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getFavoritesRequest = () => {
    return {
        type: GET_FAVORITES_REQUEST,
    };
};
export const getFavoritesSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: GET_FAVORITES_SUCCESS,
    };
};
export const getFavoritesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_FAVORITES_FAILURE,
    };
};
export const getFavorites = (authToken, parameters) => (dispatch) => {
    dispatch(getFavoritesRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(`${resolvePath.api('favorites')}?${qs.stringify(parameters)}`, config)
        .then((response) => dispatch(getFavoritesSuccess(response.data)))
        .catch((error) => {
        dispatch(getFavoritesFailure(error));
        throw error;
    });
};
export const getFavoritesId = (favoritedUser) => {
    return {
        payload: {
            favoritedUser,
        },
        type: GET_FAVORITES_ID,
    };
};
export const clearFavoritesId = () => {
    return {
        type: CLEAR_FAVORITES_ID,
    };
};
export const postFavoritesRequest = () => {
    return {
        type: POST_FAVORITES_REQUEST,
    };
};
export const postFavoritesSuccess = (favoritedUser) => {
    return {
        payload: {
            favoritedUser,
        },
        type: POST_FAVORITES_SUCCESS,
    };
};
export const postFavoritesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_FAVORITES_FAILURE,
    };
};
export const postFavorites = (authToken, parameters) => (dispatch) => {
    dispatch(postFavoritesRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .post(resolvePath.api('favorites'), parameters, config)
        .then((response) => dispatch(postFavoritesSuccess(response.data)))
        .catch((error) => {
        dispatch(postFavoritesFailure(error));
        throw error;
    });
};
export const deleteFavoritesRequest = () => {
    return {
        type: DELETE_FAVORITES_REQUEST,
    };
};
export const deleteFavoritesSuccess = (unfavoritedUser) => {
    return {
        payload: {
            unfavoritedUser,
        },
        type: DELETE_FAVORITES_SUCCESS,
    };
};
export const deleteFavoritesFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_FAVORITES_FAILURE,
    };
};
export const deleteFavorites = (authToken, parameters) => (dispatch) => {
    dispatch(deleteFavoritesRequest());
    const config = {
        data: parameters,
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .delete(resolvePath.api('favorites'), config)
        .then((response) => dispatch(deleteFavoritesSuccess(response.data)))
        .catch((error) => {
        dispatch(deleteFavoritesFailure(error));
        throw error;
    });
};
const initialState = {
    error: null,
    favoritedUser: null,
    favorites: [],
    isFetching: false,
    meta: {
        current_page: 0,
        next_page: null,
        per_page: 0,
        previous_page: 0,
        total_entries: 0,
        total_pages: 0,
    },
    page: 1,
    unfavoritedUser: null,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FORWARD: {
            return Object.assign(Object.assign({}, state), { page: state.page + 1 });
        }
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { favorites: [], page: 1 });
        }
        case GET_FAVORITES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_FAVORITES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { favorites: state.favorites.concat(action.payload.response.data), isFetching: false, meta: Object.assign({}, action.payload.response.meta) });
        }
        case GET_FAVORITES_ID: {
            return Object.assign(Object.assign({}, state), { favoritedUser: Object.assign({}, action.payload.favoritedUser), isFetching: false });
        }
        case CLEAR_FAVORITES_ID: {
            return Object.assign(Object.assign({}, state), { favoritedUser: null, isFetching: false });
        }
        case GET_FAVORITES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case POST_FAVORITES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_FAVORITES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { favoritedUser: Object.assign({}, action.payload.favoritedUser), isFetching: false });
        }
        case POST_FAVORITES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case DELETE_FAVORITES_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case DELETE_FAVORITES_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, unfavoritedUser: Object.assign({}, action.payload.unfavoritedUser) });
        }
        case DELETE_FAVORITES_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
